import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import FormikTextCopiable from '../../../components/formik-components/FormikTextCopiable';
import { LegacyInputTextComponent } from '../../../components/prime-formik';
import { matchShape } from '../../../components/prop-types';

class JobProfileDeleteForm extends Component {
  render() {
    const { match } = this.props;
    const { jobProfileId } = match.params;
    return (
      <Fragment>
        <div className="p-grid p-fluid">
          <div className="p-col-12">
            <FormattedMessage
              id="lbl.del_job_warning"
              // eslint-disable-next-line max-len
              defaultMessage="Deleting a Job Profile also deletes all Job Profile Surveys attached and removes any references to Respondent Target Job, SuperLink Target Job, etc."
            />
          </div>
          <div className="p-col-12">
            <FormattedMessage id="lbl.del_confirm.warning" defaultMessage="This action cannot be undone.">
              {text => <strong>{text}</strong>}
            </FormattedMessage>
          </div>
          <div className="p-col-12">
            <FormattedMessage id="lbl.confirmation_code" defaultMessage="Confirmation code">
              {text => <label htmlFor="confirmation_code">{text}</label>}
            </FormattedMessage>
            <Field
              name="confirmation_code"
              keyValue={jobProfileId}
              component={FormikTextCopiable}
              readOnly
            />
          </div>
          <div className="p-col-12">
            <FormattedMessage id="lbl.confirmation_code_retype" defaultMessage="Please type the confirmation code">
              {text => <label htmlFor="re_confirmation_code">{text}</label>}
            </FormattedMessage>
            <div>
              <Field
                name="re_confirmation_code"
                component={LegacyInputTextComponent}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

JobProfileDeleteForm.propTypes = {
  match: matchShape.isRequired,
};

export default JobProfileDeleteForm;
